import React, { useEffect, useState } from "react";
import { setKey } from "../store/actions";
import { connect } from "react-redux";
import countryService from "../services/country";
import { swalError } from '../utils/swal';
import Select from 'react-select';

function CountriesDropdown({ session, setKey, ...props }) {
	const [selectedOption, setSelectedOption] = useState();
	const [rows, setRows] = useState([]);

	useEffect(() => {
		reload();
	}, []);

	const reload = () => {
		countryService.getAll(session.token, ``)
			.then(result => {
				if (result.error) {
					swalError(result.error);
					return;
				}

				let t = result.data.map(k => {
					return {
						label: k.title,
						value: k._id
					};
				});
				setRows(t);

				if (props.preselected) {
					const so = t.find(k => k.value.toLowerCase() === props.preselected.toLowerCase());
					setSelectedOption(so);
				}
			});
	}

	return (
		<Select
			defaultInputValue={selectedOption}
			value={selectedOption}
			onChange={t => { setSelectedOption(t); props.selectedCountry(t.value) }}
			options={rows}
			isMulti={false}
			isSearchable={true}
			placeholder="Select country"
		/>
	);
}

const mapStateToProps = (store) => ({ session: store.session });
const mapDispatchToProps = (dispatch) => ({
	setKey: (key, value) => dispatch(setKey(key, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CountriesDropdown);
